<template>
	<view class="box">
    <view class="m-p-15">
      <view class="userInfo">
        <view class="info-l">
          <image src="../../../static/avator.png" mode="widthFix"></image>
          <view class="info-icons">
            <u-icon v-if="user.sex==0" name="man" color="#0f7ff9" bold size="24"></u-icon>
            <u-icon v-else-if="user.sex==1" name="woman" color="#ff69bf" bold size="24"></u-icon>
            <u-icon v-else name="question" color="#ff69bf" bold size="24"></u-icon>
          </view>
        </view>

        <view class="info-r">
          <view class="info-n">
<!--            用户：-->
            <span>{{user.name}}</span>

          </view>
<!--          <view class="info-id">-->
<!--            ID：<span>{{user.idNo}}</span>-->
<!--          </view>-->
        </view>
      </view>
      <view class="card-list">
        <view class="paper-card">
          <view class="company-info">
            <view class="company-i">
              <view>电话：</view>
              <span>{{getPhoneNumber(user.phone)}}</span>
            </view>
            <view class="company-i">
              <view>公司：</view>
              <span v-if="user.company && user.company.name">{{user.company.name?user.company.name:'暂无'}}</span>
            </view>
          </view>
          <view class="menu-i" @click="toMyScore">
            <view class="menu-l">
              <u-icon name="info-circle-fill" color="#0f7ff9" size="24"></u-icon>
              <view>我的成绩</view>
            </view>
            <u-icon name="arrow-right" color="#ccc" size="20"></u-icon>
          </view>
        </view>
<!--          <u-empty v-else text="暂无已完成的考试记录" mode="list"></u-empty>-->
      </view>
      <view class="loginBtn">
        <u-button @click="loginOut" type="primary" text="退出登录" shape="circle"></u-button>
      </view>
	  <image src="../../../static/my-bg.png" mode="widthFix" class="back-ground"></image>
    </view>
	</view>
</template>

<script>
  import {getExamList, getUserInfo, loginOut} from "../../../api";
  import {getCleanRecord} from "../../../api/wearhouse";
	export default {
		components:{
			
		},
		data() {
			return {
				page: 'pages/tabBar/count/count',
				statusBarHeight: '',
        user: {},
        examParams: {
          pageNum: 1,
          pageSize: 10,
          completed: 1
        },
        examList: [],
        totalPage: 0
			}
			
		},
    created(){

    },
		onLoad() {
			this.statusBarHeight = uni.getSystemInfoSync()['statusBarHeight'];
      this.getUserInfo()
		},

		methods: {
			goBack() {
				uni.switchTab({
				    url:'/pages/tabBar/firstPage/firstPage'
				});
			},

      getUserInfo(){
        getUserInfo(uni.getStorageSync('uid')).then(res => {
          if(res.code == 200) {
            this.user = res.data
          }else{
            uni.$u.toast(res.message)
          }
        })
      },

      toDetail(item,type){
        uni.setStorageSync("prevPage", '/pages/tabBar/count/count');
        uni.navigateTo({
          url: `/pages/tabBar/firstPage/exam?bank=` + encodeURIComponent(JSON.stringify(item)) + `&type=` + encodeURIComponent(JSON.stringify(type))
        })
      },
      toMyScore(){
        uni.setStorageSync("prevPage", '/pages/tabBar/count/count');
        uni.navigateTo({
          url: '/pages/tabBar/count/countDetail'
        })
      },

      loginOut(){
        uni.showModal({
          title: '提示',
          content: '是否确认退出该账号？',
          success: async function (res) {
            if (res.confirm) {
              loginOut().then(res=>{
                if(res.code == 200){
                  uni.showToast({
                    title: '账户已退出',
                    duration: 800
                  })
                  setTimeout(()=>{
                    uni.clearStorageSync();
                    uni.clearStorage();
                    uni.navigateTo({
                      url: '/pages/index/index'
                    })
                  },800)
                }
              })
            } else if (res.cancel) {
              console.log('用户点击取消');
            }
          }
        })
      },

      getPhoneNumber(phone) {
        const firstThree = phone?phone.slice(0, 3):''
        const lastFour = phone?phone.slice(-4):''
        return `${firstThree}****${lastFour}`
      }
		}
	}

</script>

<style lang='scss' scoped>
.box {
	display: flex; 
	flex-direction: column; 
	width: 100%; 
	height: 100%;
  position: relative;
  
  .back-ground{
	  width: 100%;
	  position: absolute;
	  left: 0;
	  top: 0;
	  z-index: -1
  }
}
.u-icon{
  margin: 0 !important;
}


.m-p-15{
  width: 100%;
  margin-top: 50rpx;

  .userInfo{
    display: flex;
    align-items: center;
    justify-content: left;
    width: calc(100% - 60px);
    margin: 0 auto;

    .info-l{
      width: 150rpx;
      height: 150rpx;
      border-radius: 50%;
      margin-right: 40rpx;
      position: relative;
      image{
        width: 150rpx;
        height: 150rpx;
        border-radius: 50%;
      }
      .info-icons{
        width: 48rpx;
        height: 48rpx;
        border-radius: 90%;
        position: absolute;
        bottom: 10rpx;
        right: 0;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0,0,0,.1);
      }
    }

    .info-r{
      color: #fff;
      .info-n{
        display: flex;
        align-items: center;
        font-size: 36rpx;
        font-weight: bold;
        margin-bottom: 10px;

        span{
          margin-right: 10px;
        }
      }
    }
  }

  .card-list{
    width: 100%;
    margin: 20px 0;

    .paper-card{
      width: calc(100% - 60px);
      background: #fff;
      border-radius: 20rpx;
      padding: 15px 15px 5px;
      margin: 0 auto 15px;
      box-sizing: border-box;
      box-shadow: 0 15rpx 30rpx rgba(0,0,0,.05);
      .company-info{
        border-bottom: 1px solid #e6e6e6;
        .company-i{
          display: flex;
          align-items: center;
          font-size: 28rpx;
          color: #999;
          margin-bottom: 15px;
          view{
            margin-left: 4px;
          }
          span{
            color: #333;
          }
          &:first-of-type{
            margin-bottom: 5px;
          }
        }
      }

      .menu-i{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        box-sizing: border-box;
        cursor: pointer;

        .menu-l{
          display: flex;
          align-items: center;
          font-size: 28rpx;
          view{
            margin-left: 6px;
          }
        }
      }
    }
  }
}
.loginBtn{
  width: 100%;
  position: fixed;
  bottom: 90px;
  
  ::v-deep .u-button{
	  width: 80%;
  }
}
</style>